export default "__VITE_ASSET__BqUoXkRJ__"